<template>
    <div class="for-who-section">
        <ul class="for-who-section__list"
            v-for="(column, idx) in columns"
            :key="idx"
        >
            <li class="for-who-section__item"
                v-for="item in column"
                :key="item.text"
            >
            <SvgIcon class="for-who-section__item-icon"
                :name="item.iconName"
                size="big"
            />
            <div class="for-who-section__item-content">
                <p class="for-who-section__item-text">
                    {{ item.text }}
                </p>
                <span v-if="item?.comment?.length"
                    class="for-who-section__item-comment">
                    {{ item.comment }}
                </span>
            </div>
            </li>
        </ul>
    </div>
</template>

<script>
import SvgIcon from '@/components/ui/SvgIcon';

export default {
    name: 'ForWho',
    components: {
        SvgIcon
    },
    data() {
        return {
            columns: [
                [
                    { text: 'Торговые центры, магазины', iconName: 'shop' },
                    { text: 'Образовательные учреждения', iconName: 'teacher' },
                    { text: 'Административные здания,\n офисные центры', iconName: 'building' },
                    { text: 'Нежилые помещения в жилых домах', comment: '(кроме подвальных и полуподвальных помещений)', iconName: 'building-with-tree' }
                ],
                [
                    { text: 'Медицинские учреждения', iconName: 'heart' },
                    { text: 'Предприятия общественного питания', iconName: 'building-with-annex' },
                    { text: 'Банки, финансовые учреждения', comment: '(исключая ломбарды, микрозаймы)', iconName: 'bank' },
                    { text: 'Спортивно-оздоровительные учреждения', comment: '(исключая стадионы, бассейны)', iconName: 'court-house' }
                ]
            ]
        }
    }
}
</script>

<style scoped lang="scss">
.for-who-section {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    @media #{$screen-medium} {
        flex-direction: column;
    }

    &__list {
        @include flex-width-two-in-row($gap-great);

        @media #{$screen-big} {
            @include flex-width-two-in-row($gap-big);
        }

        @media #{$screen-medium} {
            width: 100%;
        }

        & + & {
            margin-top: rem($gap-medium);
        }
    }

    &__item {
        @include resetting-vertical-indentation-of-first;

        display: flex;

        margin-top: rem($gap-big);
        padding: rem($gap-mini) 0;

        @media #{$screen-medium} {
            margin-top: rem($gap-medium);
        }

        @media #{$screen-small} {
            align-items: center;

            padding: 0;
        }

        &-icon {
            color: $primary;
        }

        &-content {
            line-height: $line-height-normal;
            
            margin-left: rem($gap-medium);
            margin-top: auto;
            margin-bottom: auto;

            @media #{$screen-big} {
                margin-left: rem($gap-normal);
            }
        }

        &-text {
            @include text-average($font-weight-medium);

            white-space: pre-line;

            @media #{$screen-big} {
                font-size: rem($font-size-normal);
            }
        }

        &-comment {
            @include text-medium($font-weight-regular);

            display: inline-block;

            color: $color-text-muted-low;

            @media #{$screen-big} {
                font-size: rem($font-size-small);
            }

            @media #{$screen-small} {
                line-height: $line-height-normal;
            }
        }
    }
}
</style>